import React from 'react'

// Same particle-assembly logo animation as the old site (public/hero.html),
// just pointed at the new media-kit logo (plain white). It sizes itself to a
// fixed fraction of the viewport (FILL_FRACTION in hero.html), so it scales
// consistently on both desktop and mobile.
export default function Hero() {
    return (
        <section className='flex overflow-hidden relative flex-col items-center w-full h-[70vh] lg:h-[85vh]'>
            <div className='overflow-hidden relative w-full flex-1'>
                <iframe src='/hero.html' className='absolute inset-0 w-full h-full' style={{border: 'none'}} title='theHackLab logo animation' />
            </div>
            <a href='https://forms.gle/1j154P2cXjkGg2968' className='btn-sweep px-8 py-3 mb-4 text-base font-semibold rounded-full lg:mb-6'>
                Apply Now
            </a>
        </section>
    )
}
